import propTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';
import PageLoader from 'components/PageLoader';
import { SearchSelect } from 'lib';
import { postSettingsDwlContact } from 'store/settings/settingsOperations';
import styles from './styles';

const OrganizationLocationForm = ({
  classes,
  closeDrawer,
  locationSettings,
  dwlUsers,
  openSnackbar,
}) => {
  const dispatch = useDispatch();

  return (
    <div className={classes.formWrapper} role="presentation">
      <Formik
        validateOnChange={false}
        validateOnBlur={true}
        initialValues={{ userId: null }}
        enableReinitialize={true}
        onSubmit={async (values, { setFieldError, setSubmitting }) => {
          const data = {
            userId: values.userId,
          };

          try {
            await dispatch(postSettingsDwlContact(data)).then(closeDrawer);
            openSnackbar('success', 'Successfully Added!');
          } catch (err) {
            openSnackbar('error', err?.response?.data?.message || err.message);
            setSubmitting(false);
          }
        }}
      >
        {({ values, handleBlur, isSubmitting, setFieldValue }) => (
          <PageLoader loading={isSubmitting}>
            <Form autoComplete="off" className={classes.formFlex}>
              <div>
                <Typography variant="h3" style={{ marginBottom: '40px' }}>
                  Add new point of contact
                </Typography>

                <IconButton
                  className={classes.closeButton}
                  onClick={closeDrawer}
                  aria-label="Close"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>

                <Grid item xs={12} className={classes.zeroPaddingTop}>
                  <label htmlFor="active">
                    <Typography variant="body1" color="textSecondary">
                      Name:
                    </Typography>
                    <SearchSelect
                      value={values.userId}
                      onChange={(id) => setFieldValue('userId', id)}
                      options={dwlUsers.filter(
                        (user) => !(locationSettings.dwlVerifyContacts || []).includes(user._id),
                      )}
                      getOptionLabel={(user) => user.profile.fullName || user.username}
                      inputProps={{
                        id: 'userId',
                        name: 'userId',
                        'aria-label': 'Name',
                        onBlur: handleBlur,
                      }}
                    />
                  </label>
                </Grid>
              </div>
              <div className={classes.buttonHolder}>
                <Button
                  color="secondary"
                  variant="outlined"
                  className={classes.cancelButton}
                  onClick={closeDrawer}
                  disabled={isSubmitting}
                  disableTouchRipple
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="primary"
                  variant="outlined"
                  className={classes.saveButton}
                  disabled={isSubmitting}
                  disableTouchRipple
                >
                  Save
                </Button>
              </div>
            </Form>
          </PageLoader>
        )}
      </Formik>
    </div>
  );
};

OrganizationLocationForm.propTypes = {
  classes: propTypes.object.isRequired,
  closeDrawer: propTypes.func.isRequired,
  openSnackbar: propTypes.func.isRequired,
  type: propTypes.string.isRequired,
  equipment: propTypes.object,
};

export default withStyles(styles)(OrganizationLocationForm);
